<template>
  <div class="be-content">
    <div class="main-content container-fluid">
      <div class="row">
        <!--Default Tabs-->
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div class="panel-heading">
              <div class="row">
                <div class="col-sm-12">1.Выберите оператора курортного сбора:</div>
                <div class="col-sm-12">
                  <select class="form-control input-sm" v-model="selectedOperator">
                    <option v-for="operator in operators" :value="operator">
                      <span>{{operator.id}}. {{operator.name}}</span>
                    </option>
                  </select>
                  <hr>
                </div>
                <template v-if="selectedOperator">
                  <div class="col-sm-12">2. Выберите период для формирования акта сверки:</div>
                  <div class="col-sm-12">
                    <form class="form-horizontal col-sm-4">
                      <div class="form-group xs-mt-10">
                        <label class="col-sm-3 control-label">С:</label>
                        <div class="col-sm-9 ">
                          <select class="form-control input-sm" v-model="dateFrom">
                            <label class="col-sm-3 control-label">Large</label>
                            <option v-for="report in reports" :value="report.date_start">
                              <span>{{report.date_end | dateFilter('MMMM YYYY')}}</span>
                            </option>
                          </select>
                      <span class="panel-subtitle" v-if="dateFrom" @click="dateFrom=null" style="cursor: pointer">Сбросить фильтр</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">По:</label>
                        <div class="col-sm-9">
                          <select class="form-control input-sm" v-model="dateTo">
                            <option v-for="report in reports" :value="report.date_end">
                              <span>{{report.date_end | dateFilter('MMMM YYYY')}}</span>
                            </option>
                          </select>
                          <span class="panel-subtitle" v-if="dateTo" @click="dateTo=null" style="cursor: pointer">Сбросить фильтр</span>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="col-sm-12" v-if="dateFrom || dateTo">
                    <hr>
                    3. Список отчетов оператора для формирования акта:
                    <button @click="selectAllReports" type="button"
                            class="btn btn-default btn-md">
                      <i class="icon mdi mdi-assignment-check"></i> Выбрать все<br>
                    </button>
                    <button @click="deselectAllReports" type="button" :disabled="checkedReports.length === 0"
                            class="btn btn-default btn-md">Снять выбор<br>
                    </button>
                    <div v-for="report in filteredReports" :key="report.id">
                      <input :id="report.id" type="checkbox" :value="report.id" v-model="checkedReports"
                             :disabled="report.status === 'Draft'">
                      <label :for="report.id">{{report.date_end | dateFilter('MMMM YYYY')}}: <span
                        v-if="report.status === 'Draft'">Предварительно</span><span v-else>Представлен {{report.date_last_submit | dateFilter('DD.MM.YYYY')}}</span></label>
                      <br>
                    </div>
                    <div class="col-sm-12" v-if="checkedReports.length === 0">
                      Для формирования отчета выберите минимум 1 отчёт.
                    </div>
                    <div class="col-sm-12" v-if="checkedReports.length > 0">
                      <button class="btn btn-success btn-lg" @click="generateActOfRevision"><i
                        class="icon mdi mdi-download">
                      </i> Загрузить акт сверки в формате Excel
                      </button>
                    </div>
                  </div>
                </template>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import moment from 'moment'
  import axios from 'axios'

  export default {
    name: "Revisions",
    data: function () {
      return {
        selectedOperator: null,
        dataReady: false,
        dateFrom: null,
        dateTo: null,
        reports: null,
        checkedReports: null
      }
    },
    computed: {
      ...
        mapGetters(
          {
            operators: 'operators',
          }
        ),
      filteredReports() {
        if (this.dateFrom && this.dateTo) {
          let dateFrom = new Date(this.dateFrom)
          let dateTo = new Date(this.dateTo)
          return this.reports.filter(report => moment(report.date_start).isSameOrAfter(moment(dateFrom))).filter(report => moment(report.date_start).isSameOrBefore(moment(dateTo)))
        }
        if (this.dateFrom) {
          let dateFrom = new Date(this.dateFrom)
          return this.reports.filter(report => moment(report.date_start).isSameOrAfter(moment(dateFrom)))
        }
        if (this.dateTo) {
          let dateTo = new Date(this.dateTo)
          return this.reports.filter(report => moment(report.date_start).isSameOrBefore(moment(dateTo)))
        }
      },
    },
    methods: {
      getOperatorNameDict(id) {
        return this.operators.find(item => Number(item.id) === Number(id)).name
      },
      getReports() {
        this.axios.get('/api/operators/' + this.selectedOperator.id + '/reports/')
          .then((response) => {
            if (response.status === 200) {
              this.reports = response.data
            }
          })
      },
      generateActOfRevision() {
        axios({
          url: '/api/generate-revision-act/' + this.selectedOperator.id,
          method: 'POST',
          data: {
            reports: this.checkedReports
          },
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          let fileName = 'Акт сверки оператор №' + this.selectedOperator.id + ' от ' + this.$options.filters.dateFilter(moment(new Date()), "DD.MM.YYYY") + '.xls'
          link.setAttribute('download', fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      },
      deselectAllReports() {
        this.checkedReports = []
      },
      selectAllReports() {
        this.checkedReports = this.filteredReports.filter(report => report.status === 'Submitted').map(report => report.id)
      },
      selectReports(reports) {
        this.checkedReports = reports.filter(report => report.status === 'Submitted').map(report => report.id)
      }
    },
    watch: {
      filteredReports() {
        this.selectReports(this.filteredReports)
      },
      selectedOperator() {
        this.checkedReports = []
        this.getReports()
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/dashboard/Revisions.vue